import StoreHeader from "../../components/layout/StoreHeader";
import StoreFooter from "../../components/layout/StoreFooter";
import { useSettings } from "../../context/SettingsContext";
import { ShieldCheck } from "lucide-react";

const DEFAULT_TEXT = `Most used parts sold by BCP Brisbane Car Parts come with a 30-90 day warranty against mechanical or electrical failure, covering the part itself.

The exact warranty period for your part is shown on the product page at the time of purchase. Please refer to your invoice for the specific warranty terms that applied to your order.

Our warranty covers parts that fail under normal use due to a manufacturing or mechanical defect. It does not cover damage caused by incorrect fitting, misuse, accident, or normal wear and tear.

Labour costs for fitting or removing a part are not covered under this warranty unless otherwise agreed in writing.

To make a warranty claim, contact us with your order number and a description of the issue. We may request photos or ask you to return the part for inspection before approving a replacement or refund.`;

export default function WarrantyPolicy() {
  const { settings } = useSettings();
  const text = settings.warranty_policy?.trim() || DEFAULT_TEXT;

  return (
    <div className="bg-white min-h-screen">
      <StoreHeader />

      <div className="bg-[#0b1a3b] py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-[#e31e24] font-mono text-[11px] uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <ShieldCheck className="h-3.5 w-3.5" /> Customer support
          </div>
          <h1 className="font-heading text-[44px] font-black uppercase text-white leading-tight">
            Warranty Policy
          </h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <div className="prose prose-zinc max-w-none whitespace-pre-line text-[15px] leading-relaxed text-zinc-700">
          {text}
        </div>
      </div>

      <StoreFooter />
    </div>
  );
}
